import * as Animations from '../assets/loaders';
import { LoadingAnimations } from '../enum/LoadingAnimation';

type AnimationType = (typeof Animations)[keyof typeof Animations];

const getAnimation = (type: LoadingAnimations): AnimationType => {
  return Animations[type] || Animations[LoadingAnimations.DEFAULT];
};
export default getAnimation;
